export default "__VITE_ASSET__BpVMSd9h__"